// Comptes de produit d'une facture de vente (27/10/2026) : même règle que le
// serveur (src/config/salesAccounts.json) — 70, 751, 752, 758, hors 7586.
import RULE from "../config/salesAccounts.json";

export function isSalesProductAccount(code) {
  const c = String(code || "");
  return /^\d+$/.test(c) && RULE.allowedPrefixes.some(p => c.startsWith(p)) && !RULE.excludedPrefixes.some(p => c.startsWith(p));
}

/** Comptes de produit du plan, regroupés : [{ label, accounts }] (groupes vides omis). */
export function groupSalesProductAccounts(plan) {
  const accounts = (plan || []).filter(a => isSalesProductAccount(a.account_code));
  return RULE.groups.map(g => ({ label: g.label, accounts: accounts.filter(a => a.account_code.startsWith(g.prefix)) })).filter(g => g.accounts.length);
}
